($__placeholder__0 = require($__placeholder__1), 
        $__placeholder__2 && $__placeholder__3.__esModule && $__placeholder__4 || {default: $__placeholder__5})


/** WEBPACK FOOTER **
 ** ../@traceur/generated/TemplateParser/9
 **/